import React from "react";
import style from './error404.module.css';

const Error404 = () => {
    return (<>
        <div className={`${style['html']}`}>
            <div className={`${style['body']}`}>
                <div className={`${style['section']}`}>
                    <h1 className={`${style['error']}`}>404</h1>
                    <div className={`${style['page']}`}>Ooops!!! The page you are looking for is not found.</div>
                    {/* <a className={`${style['back-home']}`} href="#!">Back to home</a> */}
                </div>
            </div>
        </div>
    </>);
}

export default Error404;